import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/constants/onboardingPaywallCopy";
import type { AlphaPickPricingModalCallableParams } from "@components/AlphaPick/AlphaPickPricing/types";

const I18n = I18nUtil.createScoped(Translations);

/** Onboarding / save_goal / present_risk 共用 Paywall 文案 */
export const ONBOARDING_PAYWALL_COPY_OVERRIDES: NonNullable<
  AlphaPickPricingModalCallableParams["paywallCopyOverrides"]
> = {
  title: I18n.t("Your plan is ready. Unlock full access."),
  subtitle: I18n.t("I turned your check-up into a plan you can act on."),
  features: [
    I18n.t("Reveal your comprehensive, long-term financial plan"),
    I18n.t("Track progress and flag risks the moment you drift off target"),
    I18n.t("Adapts as your life and goals change"),
  ],
  hideSocialProof: true,
};

export const ONBOARDING_PAYWALL_TRACKING_MODULE = "paywall_onboarding";

/** US2 UI15 — 第二次 goal 激活 Paywall（PRD 逐字；translate 待补） */
export const GOAL_ACTIVATE_PAYWALL_COPY_OVERRIDES: NonNullable<
  AlphaPickPricingModalCallableParams["paywallCopyOverrides"]
> = {
  title: I18n.t("Make your plan real."),
  subtitle: I18n.t("Activate it, and Ed keeps it on track for you."),
  features: [
    I18n.t("Reveal your comprehensive, long-term financial plan"),
    I18n.t("Track progress and flag risks the moment you drift off target"),
    I18n.t("Adapts as your life and goals change"),
  ],
  hideSocialProof: true,
};

export const GOAL_ACTIVATE_PAYWALL_TRACKING_MODULE = "paywall_goal_activate";

/**
 * V3.0.4 Figma `101951:175236` Paywall – Accounts（translate 只读，英文字面）。
 * Resume account sync / 过期后重连账户入口。
 */
export const ACCOUNTS_RECONNECT_PAYWALL_COPY_OVERRIDES: NonNullable<
  AlphaPickPricingModalCallableParams["paywallCopyOverrides"]
> = {
  title: I18n.t("Reconnect your accounts"),
  subtitle: I18n.t(
    "Ed'll pick up right where we left off and get back to tracking every holding.",
  ),
  features: [
    I18n.t("Track holdings, prices and returns in real time"),
    I18n.t("Net worth, spending and accounts in one place"),
    I18n.t("Flag risks before they land"),
  ],
  hideSocialProof: true,
};

export const ACCOUNTS_RECONNECT_PAYWALL_TRACKING_MODULE =
  "paywall_accounts_reconnect";
